import { Alert, AlertTitle } from '@mui/material';

export default function AlertValidationPending() {
  return (
    <Alert severity="warning">
      <AlertTitle>Invalid JSON</AlertTitle>
      Your JSON is invalid. The latest changes will be discarded if you leave Editor mode.
    </Alert>
  );
}
